export enum QuestionnaireStepStatusTextEnum {
    Incomplete = "Incomplete",
    PartiallyComplete = "Partially complete",
    Complete = "Complete"
}